import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../../utils/styles';
import LiveTournamentsList from '../../organisms/live-tournaments-list/live-tournaments-list';
import Hr from '../../atoms/hr/hr';
import AdditiveFilter, { IAdditiveFilter } from '../../organisms/additive-filter/additive-filter';
import { ITennisLiveTournament } from '../../../typings/tennis-match';
import { isPropTypeNullable } from '../../../utils/prop-types';

import { useLiveTournamentsFilters } from './tennis-live-tournaments-hooks';
import './tennis-live-tournaments.scss';

export interface ITennisLiveTournaments extends IComponent {
  tournaments: ITennisLiveTournament;
  filterModel: Omit<IAdditiveFilter, 'onChange'>;
}

const classNames = (): IClassNames =>
  makeClassNames({
    tennisLiveTournaments: 'tennis-live-tournaments',
  });

const TennisLiveTournaments: React.FC<ITennisLiveTournaments> = ({ tournaments, filterModel }) => {
  const cn = classNames();

  const { onChange, filteredTournaments, selectedSerie, selectedSerieIndex } = useLiveTournamentsFilters({
    tournaments,
    filterModel,
  });

  return (
    <div className={cn.tennisLiveTournaments}>
      <AdditiveFilter {...{ ...filterModel, onChange }} />
      <Hr />
      <LiveTournamentsList
        tournaments={filteredTournaments}
        selectedSerie={selectedSerie}
        selectedSerieIndex={selectedSerieIndex}
      />
    </div>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  TennisLiveTournaments.propTypes = {
    filterModel: PropTypes.shape({
      filterModel: AdditiveFilter.propTypes?.filterModel,
      primaryDropdownTitle: isPropTypeNullable(PropTypes.string),
      secondaryDropdownTitle: isPropTypeNullable(PropTypes.string),
    }).isRequired,
    // tournaments: PropTypes.shape(LiveTournamentsList.propTypes?.tournaments).isRequired,  // it should fix it self once fixed tournaments PropType in LiveTournamentsList
  };
}

export default TennisLiveTournaments;
